import { NavLink } from 'react-router-dom';
import { useRouter } from "../../hooks/router";
import { useEffect, useState } from "react";
import { translateWord } from "../Util/util";
import { change_password } from "../../server/requests";
import ErrorMessage from '../AlertMessage/ErrorMessage';

export default function ResetPassword({
    setPopUpTitles
}) {

    const router = useRouter()

    const [valueReset, setValueReset] = useState({
        code: '',
        new_password: '',
        repeat_password: ''
    })
    const [message, setMessage] = useState({
        text: '',
        type: '',
        show: false
    })

    useEffect(() => {
        setPopUpTitles('Reset Password')
    }, [])

    useEffect(() => {
        if (router.query.code) {
            setValueReset({ ...valueReset, code: router.query.code })
            if (router.query.type == 'error') {
                setMessage({
                    text: router.query.m,
                    type: 'error',
                    show: true
                })
                hide_mesaage('redirect')

            }
        }
    }, [router.query])

    const onChange = (e) => {

        const { name, value } = e.target;

        if (value.length > parseInt(e.target.max) && name === 'code') return;

        setValueReset({ ...valueReset, [name]: value });

    }

    const onSubmit = (e) => {
        e.preventDefault();
        change_password(valueReset, res => {
            setMessage({
                text: res,
                type: 'success',
                show: true
            })
            hide_mesaage('redirect')
        }, err => {
            console.log(err)
            setMessage({
                text: err,
                type: 'error',
                show: true
            })
            hide_mesaage()

        })
    }

    const hide_mesaage = (type) => {
        setTimeout(() => {
            setMessage({
                text: '',
                type: '',
                show: false
            })

            if (type === 'redirect') {
                // let _url = ''

                // if (router.query.from) _url = '/auth?from=' + router.query.from

                // else _url = '/auth'
                router.push('/auth')

            }


        }, 3000)
    }

    return (
        <>
            <ErrorMessage text={message.text} type={message.type} show={message.show} />
            <div className="login">
                <form onSubmit={onSubmit}>
                    {/* <p className='check_email'>
                        {translateWord('Please check Your email for code','Please check Your email for code')}
                    </p> */}
                    {/* <label htmlFor="">{translateWord('Code', 'Code')}:</label>
                    <input
                        type="text"
                        max={6}
                        value={valueReset.code}
                        name={'code'}
                        onChange={onChange}
                        placeholder={translateWord('Code')}
                    /> */}
                    <label htmlFor="">{translateWord('Password', 'Password')}:</label>
                    <input
                        type="password"
                        value={valueReset.new_password}
                        name={'new_password'}
                        onChange={onChange}
                        placeholder={translateWord('Password', 'Password')}
                    />
                    <label htmlFor="">{translateWord('Confirm Password', 'Confirm Password')}:</label>
                    <input
                        type="password"
                        value={valueReset.repeat_password}
                        name={'repeat_password'}
                        onChange={onChange}
                        placeholder={translateWord('Confirm Password', 'Confirm Password')}
                    />
                    <button type={'submit'} className={'card_color forgot'}>{translateWord('Reset password', 'Reset password')}</button>

                    <p>
                        {translateWord('Already have an account?', 'Already have an account?')}{' '}
                        <NavLink to={'/auth'}>{translateWord('Sign In', 'Sign In')} </NavLink>
                    </p>
                </form>
            </div>
        </>
    )
}
